import { UniRoColumn } from "./Bit/UniRoColumn";

export const PluginsMap: any = {
    'bit-UniRoColumn': UniRoColumn,

}